import { render, staticRenderFns } from "./profile-general.vue?vue&type=template&id=47ba1eb3&scoped=true"
import script from "./profile-general.vue?vue&type=script&lang=js"
export * from "./profile-general.vue?vue&type=script&lang=js"
import style0 from "./profile-general.vue?vue&type=style&index=0&id=47ba1eb3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ba1eb3",
  null
  
)

export default component.exports